import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from './component-header.component';
import { PipeModule } from 'src/app/pipe/pipe.module';

@NgModule({
  declarations: [
    ComponentHeaderComponent
  ],
  imports: [
    CommonModule,
    PipeModule
  ],
  exports:[
    ComponentHeaderComponent
  ]
})
export class ComponentHeaderModule { }
